import React from 'react';
import SectionHeader from './SectionHeader';
import YesNoRadio from './YesNoRadio';
import NotesInput from './NotesInput';

/**
 * Section 2 — Accounts & Beneficiaries.
 *
 * Two quick yes/no questions about recent life changes that affect
 * financial planning.
 */
export default function StepAccountsBeneficiaries({ data, onChange }) {
  function update(field, value) {
    onChange({ ...(data || {}), [field]: value });
  }

  return (
    <div>
      <SectionHeader
        number={2}
        title="Accounts & Beneficiaries"
        tip="Let us know about any changes since your last review."
        showAnnualNote={false}
      />

      <div className="cashflow-section-card">
        <YesNoRadio
          id="added_investment_accounts"
          label={<>Have you added any investment account(s)? <span className="text-danger">*</span></>}
          value={data?.added_investment_accounts}
          onChange={(val) => update('added_investment_accounts', val)}
        />

        {data?.added_investment_accounts === 'yes' && (
          <div className="mb-3">
            <label htmlFor="new_accounts_details" className="form-label small">
              What accounts did you add?
            </label>
            <textarea
              id="new_accounts_details"
              className="form-control"
              rows={2}
              value={data?.new_accounts_details || ''}
              onChange={(e) => update('new_accounts_details', e.target.value)}
            />
          </div>
        )}

        <hr className="my-3" />

        <YesNoRadio
          id="beneficiaries_changed"
          label={<>Have your beneficiaries changed? <span className="text-danger">*</span></>}
          value={data?.beneficiaries_changed}
          onChange={(val) => update('beneficiaries_changed', val)}
        />

        {data?.beneficiaries_changed === 'yes' && (
          <div>
            <label htmlFor="beneficiaries_details" className="form-label small">
              What changed?
            </label>
            <textarea
              id="beneficiaries_details"
              className="form-control"
              rows={2}
              value={data?.beneficiaries_details || ''}
              onChange={(e) => update('beneficiaries_details', e.target.value)}
            />
          </div>
        )}
      </div>

      <NotesInput
        value={data?.notes}
        onChange={(val) => update('notes', val)}
      />
    </div>
  );
}
